import { render, staticRenderFns } from "./larvicide_details.vue?vue&type=template&id=dc80d2d0&"
import script from "./larvicide_details.vue?vue&type=script&lang=js&"
export * from "./larvicide_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports